import {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import XLSX from 'xlsx';
import { NotificationManager } from 'react-notifications';
import DragAndDrop from "../../common/simple/dragAndDrop";
import { useAccessToken } from '../../common/hooks/useAccessToken';
import BllinkUtils from '../../common/utils/utils';
import { isAdminSelector } from '../../store/auth/selectors';
import { showLoader, hideLoader } from '../../store/common/slice';
import UploadDownloadToolBar from "../paymentSettings/uploadDownloadToolBar";
import {getBuildingTitle} from '../../store/buildings/actions';

const CollectionStatus = ({ match, history }) => {
    const { buildingID } = match.params;
    const year = BllinkUtils.BllinkTime.getCurrentYear();
    const dispatch = useDispatch();
    const client = useAccessToken();
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();
    const titleData = useSelector((state) => state.buildings.titleData);

    useEffect(() => {
        if (!titleData.translationKey) dispatch(getBuildingTitle({buildingID}));
    }, []);

    const uploadCollectionStatusFile = async jsonData => {
        dispatch(showLoader());
        const payload = {
            building_data: JSON.stringify(jsonData),
            overwriteOnGoing: false
        };
        const response = await client.post(`/operations/migrate-building-to-bllink/${buildingID}`, payload);
        if (response) {
            if (response.worker){
                NotificationManager.success(t('buildings.collection_status_uploaded_in_background'));
            }else {
                NotificationManager.success(t('buildings.collection_status_uploaded'));
                setTimeout(() => {
                    history.push({
                        pathname: `/reports/yearly-by-months/${buildingID}/${year}`
                    });
                }, 2000)
            }
        } else {
            NotificationManager.error(t('buildings.something_wrong'));
        }

        dispatch(hideLoader());
    };

    const handleDrop = async e => {
        const hasFilesToUpload = e.dataTransfer.files && e.dataTransfer.files.length > 0;
        if (hasFilesToUpload) {
            let reader = new FileReader();
            reader.readAsBinaryString(e.dataTransfer.files[0]);

            reader.onload = async function (e) {
                let cfb = XLSX.read(e.target.result, {type: 'binary'});
                let sheetData = cfb.Sheets[cfb.SheetNames[0]];
                let jsonData = XLSX.utils.sheet_to_json(sheetData);
                await uploadCollectionStatusFile(jsonData);
            }
        }
    };

    const parentState = {
        isOneTime: false,
        collectionStatus: true,
    };

    return (
        <div className="ensure-height">
            <h1 className='page-title'>
                {titleData.translationKey && (
                    <span className='building-title'>{t('payments.' + titleData.translationKey, titleData)}</span>
                )}
            </h1>

            <UploadDownloadToolBar
                parentState={parentState}
                buildingID={buildingID}
                onUploadCollectionStatusFile={uploadCollectionStatusFile}
            />

            <DragAndDrop
                handleDrop={handleDrop}
            >
                <div className={"container drag-to-upload-container"}>
                    <div className={"drag-to-upload bllink-font"}>
                        <p>{t('buildings.collection_status_title')}</p>
                        <p>{t('reports.drag_and_drop_info')}</p>
                    </div>
                </div>
            </DragAndDrop>
        </div>
    )
}

export default CollectionStatus;
